import { useMutation, useQuery } from "@tanstack/react-query";
import { adverseEventFollowupApiService } from "./adverseeventfollowup.api";

export const useAdverseEventFollowupApi = (params?: any) => {

  const SelectQuery = useQuery({
    queryKey: ["adverse-event-followup-select", params],
    queryFn: () => adverseEventFollowupApiService.getSelectById(params),
    enabled: !!params?.adverseeventid && params?.enabled !== false,
  });

  const InsertMutation = useMutation({
    mutationFn: (data: any) => adverseEventFollowupApiService.insertData(data),
  });

  const UpdateMutation = useMutation({
    mutationFn: (data: any) => adverseEventFollowupApiService.updateData(data),
  });

  const DeleteMutation = useMutation({
    mutationFn: (data: any) => adverseEventFollowupApiService.deleteData(data),
  });


  return {
    SelectQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
  };
};
